/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Segment } from './Segment';
import {
    SegmentFromJSON,
    SegmentFromJSONTyped,
    SegmentToJSON,
    SegmentToJSONTyped,
} from './Segment';

/**
 * 
 * @export
 * @interface Itinerary
 */
export interface Itinerary {
    /**
     * The itinerary code
     * @type {string}
     * @memberof Itinerary
     */
    code: string;
    /**
     * The itinerary name
     * @type {string}
     * @memberof Itinerary
     */
    name: string;
    /**
     * List of segments
     * @type {Array<Segment>}
     * @memberof Itinerary
     */
    segments?: Array<Segment>;
    /**
     * URL leading to the image of the itinerary/route
     * @type {string}
     * @memberof Itinerary
     */
    imageUrl?: string;
}

/**
 * Check if a given object implements the Itinerary interface.
 */
export function instanceOfItinerary(value: object): value is Itinerary {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ItineraryFromJSON(json: any): Itinerary {
    return ItineraryFromJSONTyped(json, false);
}

export function ItineraryFromJSONTyped(json: any, ignoreDiscriminator: boolean): Itinerary {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': json['name'],
        'segments': json['segments'] == null ? undefined : ((json['segments'] as Array<any>).map(SegmentFromJSON)),
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
    };
}

export function ItineraryToJSON(json: any): Itinerary {
    return ItineraryToJSONTyped(json, false);
}

export function ItineraryToJSONTyped(value?: Itinerary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'segments': value['segments'] == null ? undefined : ((value['segments'] as Array<any>).map(SegmentToJSON)),
        'imageUrl': value['imageUrl'],
    };
}

